import React from "react";
import * as actionTypes from "../../store/actions/register";
import { connect } from "react-redux";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import Avatar from "react-avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { MUTATION_LOGIN } from "../../service/ApolloClient/ApolloMutation";
import { client } from "../../service/ApolloClient/ApolloAuthClient";
import { ErrorToast, SuccessToast } from "../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="fereydooni-bongah.ir/">
        Portal
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Auth = (props) => {
  const classes = useStyles();
  const [username, setUsername] = React.useState();
  const [password, setPassword] = React.useState();
  const [loading, setLoading] = React.useState(false);

  const handleLogin = () => {
    setLoading(true);
    client
      .mutate({
        mutation: MUTATION_LOGIN,
        variables: {
          username: username,
          password: password,
        },
      })
      .then((res) => {
        let status = res.data.login;

        if (status) {
          SuccessToast("با موفقیت وارد شدید");
          localStorage.setItem("token", status);

          props.history.push("/");
        } else {
          ErrorToast("اطلاعات وارد شده صحیح نمی باشد");
        }
        setLoading(false);
      })
      .catch((err) => {
        ErrorToast("مشکل در دریافت اطلاعات");
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          ورود به سیستم مدیریت چک
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="نام کاربری"
            name="email"
            autoComplete="email"
            disabled={loading}
            autoFocus
            onChange={(event) => {
              setUsername(event.target.value);
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="کلمه عبور"
            type="password"
            id="password"
            disabled={loading}
            autoComplete="current-password"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
          />
          {loading ? (
            <LinearProgress />
          ) : (
            <Button
              type="button"
              onClick={handleLogin}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              ورود
            </Button>
          )}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    RegisterClear: () => dispatch(actionTypes.registerCLEAR()),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(Auth));
